"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMaxDate = exports.areTravelDatesEqual = exports.getDatesForFlexibleRange = exports.containsDurationValue = exports.getMaxDurationInDays = exports.getMinDurationInDays = exports.getShortInformation = exports.formatDuration = exports.expandRange = exports.SHORT_INFO_FORMAT = exports.MAX_DATE_RANGE_ON_EXACT_SEARCH = void 0;
const addDays_1 = __importDefault(require("date-fns/addDays"));
const eachDayOfInterval_1 = __importDefault(require("date-fns/eachDayOfInterval"));
const isAfter_1 = __importDefault(require("date-fns/isAfter"));
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const libs_utils_1 = require("@hotelplan/libs.utils");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
exports.MAX_DATE_RANGE_ON_EXACT_SEARCH = 31;
exports.SHORT_INFO_FORMAT = 'dd.MM.yyyy';
function expandRange(range) {
    if (!range || !range.length) {
        return [];
    }
    if (range.length === 1) {
        return range;
    }
    const [start, end] = range;
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}
exports.expandRange = expandRange;
function formatDuration(t, { duration, type }) {
    const formattedType = t(`common:${type}`, {
        count: duration[duration.length - 1],
    });
    return duration.length === 1
        ? t('search:dates.duration.exact', {
            from: duration[0],
            type: formattedType,
        })
        : t('search:dates.duration.range', {
            from: duration[0],
            to: duration[duration.length - 1],
            type: formattedType,
        });
}
exports.formatDuration = formatDuration;
function getShortInformation(t, params) {
    const { departureDate, returnDate, durationData, onlyDepartureDate, onlyReturnDate, showDuration = false, infoFormat = exports.SHORT_INFO_FORMAT, } = params;
    const formattedDuration = formatDuration(t, durationData);
    const formattedDepartureDate = (0, libs_utils_1.formatDate)(departureDate, infoFormat);
    const formattedReturnDate = returnDate
        ? (0, libs_utils_1.formatDate)(returnDate, infoFormat)
        : '...';
    const formattedTravelDates = onlyDepartureDate
        ? formattedDepartureDate
        : onlyReturnDate
            ? formattedReturnDate
            : `${formattedDepartureDate} – ${formattedReturnDate}`;
    const formattedTravelDatesWithDuration = showDuration
        ? `${formattedTravelDates} / ${formattedDuration}`
        : formattedTravelDates;
    return {
        departureDate: formattedDepartureDate,
        returnDate: formattedReturnDate,
        duration: formattedDuration,
        travelDates: formattedTravelDatesWithDuration,
    };
}
exports.getShortInformation = getShortInformation;
function getMinDurationInDays(duration) {
    return duration.type === 'week'
        ? duration.duration[0] * 7
        : duration.duration[0];
}
exports.getMinDurationInDays = getMinDurationInDays;
function getMaxDurationInDays(duration) {
    const maxDuration = duration.duration[duration.duration.length - 1];
    return duration.type === 'week' ? maxDuration * 7 : maxDuration;
}
exports.getMaxDurationInDays = getMaxDurationInDays;
function containsDurationValue(durationValueToFind, durationValues) {
    const min = getMinDurationInDays(durationValueToFind);
    const max = getMaxDurationInDays(durationValueToFind);
    return durationValues.some(value => {
        const currMin = getMinDurationInDays(value);
        const currMax = getMaxDurationInDays(value);
        return currMin === min && currMax === max;
    });
}
exports.containsDurationValue = containsDurationValue;
function getDatesForFlexibleRange(rangeStart, duration, returnDate, maxDate) {
    if (returnDate)
        return [];
    const durationInDays = getMaxDurationInDays(duration);
    if (durationInDays < 2)
        return [];
    const start = (0, addDays_1.default)(rangeStart, 1);
    const end = (0, addDays_1.default)(rangeStart, durationInDays);
    if ((0, isAfter_1.default)(end, maxDate)) {
        return (0, isAfter_1.default)(start, maxDate)
            ? []
            : (0, eachDayOfInterval_1.default)({ start, end: maxDate });
    }
    return (0, eachDayOfInterval_1.default)({ start, end });
}
exports.getDatesForFlexibleRange = getDatesForFlexibleRange;
function areTravelDatesEqual(aITravelDatesState, bITravelDatesState) {
    return ((0, libs_utils_1.isEqual)(aITravelDatesState.departureDate, bITravelDatesState.departureDate) &&
        (0, libs_utils_1.isEqual)(aITravelDatesState.returnDate || new Date(), bITravelDatesState.returnDate || new Date()) &&
        (0, fast_deep_equal_1.default)(aITravelDatesState.duration, bITravelDatesState.duration));
}
exports.areTravelDatesEqual = areTravelDatesEqual;
// Max travel period is MAX_DATE_RANGE_ON_EXACT_SEARCH days on exact search.
// Further dates are not clickable if returnDate is not selected
function calculateMaxDate(departureDate, returnDate, searchType) {
    const today = (0, libs_utils_1.getTodaysDate)();
    const maxAllowedDate = (0, addDays_1.default)(today, 365);
    const maxDate = searchType === supergraph_api_1.FdrTravelPeriodType.Exact && !returnDate
        ? (0, addDays_1.default)(departureDate, exports.MAX_DATE_RANGE_ON_EXACT_SEARCH)
        : maxAllowedDate;
    return (0, isAfter_1.default)(maxDate, maxAllowedDate) ? maxAllowedDate : maxDate;
}
exports.calculateMaxDate = calculateMaxDate;
//# sourceMappingURL=fdr-travel-dates.utils.js.map